<template>
    <div :class="['booking-form us-source-booking brand-booking-form main-booking-form', { 'app-padding': mobileApp }]">
        <div id="title-message">
            <ul class="nav nav-tabs">
                <li class="nav-item search-tab" role="presentation">
                    <a class="search-nav-link d-block active" href="#search-pane" data-toggle="tab">
                        <img class="search-icon" :src="brandingImagesPath('/images/svgs/car-front.svg')" alt="" />
                        {{ carRentLabel }}
                    </a>
                </li>
                <li v-if="brand !== 'usave'" class="nav-item search-tab" role="presentation">
                    <a class="search-nav-link d-block" href="#booking-pane" data-toggle="tab">
                        <img class="search-icon" :src="brandingImagesPath('/images/svgs/ticket.svg')" alt="" />
                        {{ trans('booking-process.find-booking.my_bookings') }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div class="tab-pane active" id="search-pane">
                <form v-cloak>
                    <errors></errors>

                    <div>
                        <div>
                            <label class="d-block d-md-none mt-4">
                                {{ trans('booking-process.search.pickup_date_label') }}
                            </label>
                            <label class="d-none d-md-block mt-4">
                                {{ trans('booking-process.search.pickup_location_label') }}
                            </label>
                        </div>
                        <div v-show="franchiseCountry && !countrySelected">
                            <div class="franchise-country-picker" v-if="franchiseCountry">
                                <div class="franchise-country-picker-button">
                                    <button type="button" class="btn btn-solid" @click="countrySelected = true">
                                        {{ franchiseCountry.name }}
                                    </button>
                                </div>
                                <div class="franchise-country-picker-button">
                                    <button type="button" class="btn btn-solid" @click="redirectToMainSite">
                                        {{ trans('shared.worldwide') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-show="!franchiseCountry || countrySelected" v-loading="locationsLoading">
                            <location-search v-if="!locationsLoading" v-model="pickupLocation" :locked="lockedPickupLocation"> </location-search>
                        </div>
                        <div :class="franchiseCountry && !countrySelected && 'blocked-fields'">
                            <div class="mobile">
                                <div class="mobile-date-inputs">
                                    <div class="form-group row date-picker-inputs">
                                        <div class="col-6">
                                            <div class="summary">
                                                <p>
                                                    <label class="m-0">{{ trans('booking-process.search.pickup_date_full_label') }}</label>
                                                </p>
                                            </div>
                                            <div class="date-picker-input-sm" @click="openPickupDatePicker">
                                                <date-picker v-model="pickupDate" @dateSelected="openDropoffDatePicker" ref="pickupDatePicker"></date-picker>

                                                <div class="date-overlay">
                                                    <div class="date-fields">
                                                        <span class="date-picker-input-month-sm">
                                                            {{ formattedPickupDate.month }}
                                                        </span>
                                                        <span class="date-picker-input-day-sm">
                                                            {{ formattedPickupDate.day }}
                                                        </span>
                                                    </div>
                                                    <div class="date-icon-field">
                                                        <img class="date-picker-icon" :src="brandingImagesPath('/images/svgs/calendar.svg')" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="summary">
                                                <p>
                                                    <label class="m-0">{{ trans('booking-process.search.time_only_label') }}</label>
                                                </p>
                                            </div>

                                            <div class="date-picker-input-sm">
                                                <div class="date-picker">
                                                    <time-picker v-if="brand !== 'usave'" v-model="pickupTime" noborder="false"></time-picker>
                                                    <usave-time-picker v-else v-model="pickupTime"></usave-time-picker>
                                                </div>

                                                <div v-if="brand !== 'usave'" class="date-overlay">
                                                    <div class="date-fields">
                                                        <span class="date-picker-input-month-sm">
                                                            {{ formatPickupTime }}
                                                        </span>
                                                    </div>
                                                    <div class="date-icon-field">
                                                        <img class="time-picker-icon" :src="brandingImagesPath('/images/svgs/clock.svg')" alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group dropoff-date-picker">
                                        <div class="row mt-3 date-picker-inputs">
                                            <div class="col-6">
                                                <div class="summary">
                                                    <p>
                                                        <label class="m-0">{{ trans('booking-process.search.dropoff_date_full_label') }}</label>
                                                    </p>
                                                </div>
                                                <div class="date-picker-input-sm" @click="openDropoffDatePicker">
                                                    <date-picker v-model="dropoffDate" :minimumDate="pickupDate" ref="dropoffDatePicker"></date-picker>
                                                    <div class="date-overlay">
                                                        <div class="date-fields">
                                                            <span class="date-picker-input-month-sm">
                                                                {{ formattedDropoffDate.month }}
                                                            </span>
                                                            <span class="date-picker-input-day-sm">
                                                                {{ formattedDropoffDate.day }}
                                                            </span>
                                                        </div>
                                                        <div class="date-icon-field">
                                                            <img class="date-picker-icon" :src="brandingImagesPath('/images/svgs/calendar.svg')" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="summary">
                                                    <p>
                                                        <label class="m-0">{{ trans('booking-process.search.time_only_label') }}</label>
                                                    </p>
                                                </div>

                                                <div class="date-picker-input-sm">
                                                    <div class="date-picker">
                                                        <time-picker v-if="brand !== 'usave'" v-model="dropoffTime" noborder="false"></time-picker>
                                                        <usave-time-picker v-else v-model="dropoffTime"></usave-time-picker>
                                                    </div>

                                                    <div v-if="brand !== 'usave'" class="date-overlay">
                                                        <div class="date-fields">
                                                            <span class="date-picker-input-month-sm">
                                                                {{ formatDropoffTime }}
                                                            </span>
                                                        </div>
                                                        <div class="date-icon-field">
                                                            <img class="time-picker-icon" :src="brandingImagesPath('/images/svgs/clock.svg')" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row driver-age-inputs mb-4">
                                <light-switch class="d-none d-md-block col-12" :text="trans('booking-process.search_additional.driver_between')" v-model="driverHasStandardAge"></light-switch>

                                <div class="d-block d-md-none col-8 p-0 pl-4">
                                    <span class="driver-age-label"> {{ trans('booking-process.search_additional.driver_between') }}</span>
                                </div>
                                <div class="us-source-booking d-block d-md-none col-2">
                                    <label class="checkbox-container">
                                        <input class="search-form-check-input" type="checkbox" v-model="driverHasStandardAge" />
                                        <span class="checkmark new-checkmark"></span>
                                    </label>
                                </div>

                                <div class="col-12 driver-age-input" v-if="!driverHasStandardAge">
                                    <validated-input
                                        :label-text="trans('booking-process.search_additional.driver_age')"
                                        input-id="age"
                                        name="age"
                                        type="number"
                                        :placeholder="trans('booking-process.search_additional.driver_age')"
                                        v-model="driverAge"
                                        rules="required"
                                        form-type="vertical"
                                        :columns="12"
                                        :formatted-name="trans('booking-process.search_additional.driver_age')"
                                        pattern="[0-9]*"
                                    />
                                </div>
                            </div>

                            <div class="row promo-code-input mb-4">
                                <div class="col-8">
                                    <span class="promo-label"> {{ trans('booking-process.search_additional.promo_code') }}?</span>
                                </div>
                                <div class="us-source-booking d-block d-md-none col-2">
                                    <label class="checkbox-container">
                                        <input class="search-form-check-input" type="checkbox" v-model="driverHasPromoCode" />
                                        <span class="checkmark new-checkmark"></span>
                                    </label>
                                </div>
                                <div class="d-block d-md-none col-12 driver-age-input" v-if="driverHasPromoCode">
                                    <validated-input
                                        :disabled="franchiseCountry && !countrySelected"
                                        autocomplete="off"
                                        input-id="promo-code"
                                        name="promo_code"
                                        type="text"
                                        :placeholder="trans('booking-process.search_additional.promo_code')"
                                        v-model="promoCode"
                                        rules=""
                                        form-type="vertical"
                                        :columns="12"
                                        :formatted-name="trans('booking-process.search_additional.promo_code')"
                                    />
                                </div>
                            </div>
                            <div class="submit-button">
                                <gm-button class="regular-button" type="next" @click="submit" :busy="form.busy" :disabled="form.disabled || (franchiseCountry && !countrySelected)">
                                    {{ trans('booking-process.search_additional.search') }}
                                </gm-button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="tab-pane mt-4" id="booking-pane">
                <find-booking></find-booking>
            </div>
        </div>
    </div>
</template>

<script>
import Bus from '../../bus';
import lang from '../../shared/mixins/lang';
import Errors from '../../shared/components/ui/Errors.vue';
import ValidatedInput from '../../shared/components/validation/Input.vue';
import LocationSearch from '../../shared/components/ui/LocationSearch.vue';
import DatePicker from '../../shared/components/ui/DatePicker.vue';
import TimePicker from '../../shared/components/ui/TimePicker.vue';
import UsaveTimePicker from '../../shared/components/ui/UsaveTimePicker.vue';
import LightSwitch from 'greenmotion-shared/Components/shared/LightSwitch';
import GmButton from 'greenmotion-shared/Components/shared/Button';
import SearchForm from 'greenmotion-shared/mixins/SearchForm';
import 'vue2-timepicker/dist/VueTimepicker.css';
import Globals from '../../../globals/Globals';
import DevTools from '../../dev-tools/config/main';
import branding from '../../shared/mixins/branding';
import { mapGetters } from 'vuex';
import { setDropoffDifferent } from 'greenmotion-shared/vuex/search/actions';

export default {
    components: {
        Errors,
        ValidatedInput,
        LocationSearch,
        DatePicker,
        TimePicker,
        UsaveTimePicker,
        LightSwitch,
        GmButton,
    },
    mixins: [lang, SearchForm, DevTools, branding],
    data() {
        return {
            urlParams: new URLSearchParams(window.location.search),
            filters: {
                size: null,
                passengers: null,
                fuel_type: null,
                transmission: null,
                min_price: null,
                max_price: null,
            },
            countrySelected: false,
            form: {
                busy: false,
                success: true,
                disabled: false,
            },
            driverHasStandardAge: true,
            driverHasPromoCode: false,
            datePickerTheme: {
                color: 'gm',
            },
            locationsLoading: false,
            lockedPickupLocation: false,
            locale: 'en',
            authenticated: window.greenmotion.authenticated || false,
            brand: window.brand || 'greenmotion',
        };
    },
    watch: {
        pickupLocation(location) {
            Bus.$emit('updateQueryLocation');
        },
        dropoffLocation(location) {
            let scrollTo = document.getElementById('home-banner');
            scrollTo ? scrollTo.scrollIntoView({ behavior: 'smooth' }) : null;
            Bus.$emit('updateQueryLocation');
        },
        driverHasStandardAge(isChecked) {
            if (isChecked) {
                this.$store.dispatch('setDriverAge', 30);
            }
        },
        driverHasPromoCode(isChecked) {
            if (!isChecked) {
                this.promoCode = '';
            }
        },
    },
    computed: {
        dates: {
            get() {
                return {
                    start: moment.utc(this.$store.state.search.search.pickupDate),
                    end: moment.utc(this.$store.state.search.search.dropoffDate),
                };
            },
            set(dates) {
                this.$store.dispatch('setPickupDate', dates.start);
                this.$store.dispatch('setDropoffDate', dates.end);
            },
        },
        mobileApp() {
            const subdomain = window.location.hostname.split('.')[0];

            if (subdomain.startsWith('app') && this.screenType === 'mobile') {
                return true;
            }

            return null;
        },
        formatPickupTime() {
            return Globals.formatTimeForLocale(this.pickupTime, this.locale);
        },
        formatDropoffTime() {
            return Globals.formatTimeForLocale(this.dropoffTime, this.locale);
        },
        datePickerLayout() {
            return this.$screens({
                default: {
                    columns: 1,
                    rows: 1,
                    isExpanded: true,
                },
                md: {
                    columns: 2,
                    rows: 1,
                    isExpanded: false,
                },
            });
        },
        dropoffLocation: {
            get() {
                return this.$store.state.search.search.dropoffLocation;
            },
            set(location) {
                this.$store.dispatch('setDropoffLocation', location);
            },
        },
        dropoffDifferent: {
            get() {
                return this.$store.state.search.search.dropoffDifferent;
            },
            set(different) {
                this.$store.dispatch('setDropoffDifferent', different);
            },
        },
        formattedPickupDate() {
            return this.formatDate(moment(this.dates.start), 'pickup');
        },
        formattedDropoffDate() {
            return this.formatDate(moment(this.dates.end), 'dropoff');
        },
        isCarTrawlerLocation() {
            return this.pickupLocation.provider === 'CTR';
        },
        franchiseCountry() {
            const countryId = window.greenmotion.franchiseCountry;
            if (!countryId) {
                return null;
            }
            return this.countries.find((country) => {
                return country.id == countryId;
            });
        },
        carRentLabel() {
            if (this.brand === 'usave') {
                return this.trans('booking-process.find-booking.car_rental');
            }
            return this.trans('booking-process.find-booking.car_rent');
        },
        ...mapGetters({
            userLocation: 'getUserLocation',
            quote: 'getQuote',
            locations: 'getLocations',
            countries: 'getCountries',
            screenType: 'getScreenType',
        }),
    },
    methods: {
        isEmbedded() {
            return this.urlParams.get('iframe') === 'true';
        },
        openPickupDatePicker() {
            this.$refs.pickupDatePicker.open();
        },
        openDropoffDatePicker() {
            this.$refs.dropoffDatePicker.open();
        },
        formatDate(date, type = 'pickup') {
            if (!date.isValid()) {
                let startDate = moment(this.dates.start);
                // If dropoff date is invalid set "to" date = to "from" date, this will prevent selecting a "to" date less that "from" date
                if (type == 'dropoff') {
                    this.$store.dispatch('createError', {
                        response: {
                            status: 422,
                            data: {
                                error: {
                                    message: this.trans('validation.after', {
                                        attribute: 'end date',
                                        date: 'start date',
                                    }),
                                },
                            },
                        },
                    });
                }
                // If pickup date is less that today, set "to" date to today
                if (type == 'pickup') {
                    this.$store.dispatch('createError', {
                        response: {
                            status: 422,
                            data: {
                                error: {
                                    message: this.trans('validation.date', {
                                        attribute: 'start date',
                                    }),
                                },
                            },
                        },
                    });
                    startDate = moment(new Date());
                }
                return {
                    weekday: startDate.format('ddd'),
                    day: startDate.format('DD'),
                    month: startDate.format('MMM'),
                };
            }
            return {
                weekday: date.format('ddd'),
                day: date.format('DD'),
                month: date.format('MMM'),
            };
        },
        redirectToCarTrawlerEngine() {
            const parameters = {
                pickupLocationId: this.pickupLocation.car_trawler_id,
                returnLocationId: this.dropoffLocation ? this.dropoffLocation.car_trawler_id : this.pickupLocation.car_trawler_id,
                age: this.driverAge,
                pickupDateTime: this.pickupDateTime,
                returnDateTime: this.dropoffDateTime,
            };
            const queryString = Object.keys(parameters)
                .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(parameters[key]))
                .join('&');
            const path = `/ct-quotes?${queryString}`;
            if (this.isEmbedded()) {
                top.location = path;
            } else {
                this.$router.push({
                    path: path,
                });
                this.$router.go(0);
            }
        },
        submit() {
            if (this.pickupLocation == null) {
                document.querySelectorAll('.algolia-autocomplete .real-input.aa-input')[0].focus();
                return;
            }
            this.validateChildInputs();
            if (!this.formIsValid()) {
                return;
            }
            this.form.busy = true;
            this.$store.dispatch('deleteError');
            if (this.isCarTrawlerLocation) {
                return this.redirectToCarTrawlerEngine();
            }
            this.isEmbedded() ? this.postFrameSearch() : this.postSearch();
        },
        postSearch() {
            this.$store
                .dispatch('postSearch')
                .then((id) => {
                    this.form.busy = false;
                    this.form.success = true;
                    if (id) {
                        const path = '/quotes/' + id;

                        if (this.$router) {
                            this.$router.push({
                                path: path,
                            });
                            this.$router.go(0);

                            return;
                        }

                        window.location.href = path;
                    }
                })
                .catch((error) => {
                    this.form.busy = false;
                    this.form.success = false;
                    this.$store.dispatch('createError', error);
                });
        },
        setFilter(paramName) {
            if (this.urlParams.has(paramName)) {
                if (this.filters.hasOwnProperty(paramName)) {
                    this.filters[paramName] = encodeURIComponent(this.urlParams.get(paramName));
                }
            }
        },
        redirectWalkIn(pickupLocation) {
            top.location = `${window.location.protocol}//${window.base_domain}/locations/${pickupLocation.id}`;
        },
        postFrameSearch() {
            const pickupLocation = this.$store.state.search.search.pickupLocation;

            this.$store
                .dispatch('postFrameSearch')
                .then(({ id, currency, guestToken }) => {
                    this.form.busy = false;
                    this.form.success = true;

                    if (id) {
                        const path = '/quotes/' + id;

                        let opts = [guestToken ? `gt=${guestToken}` : null, `c=${currency}`];

                        this.urlParams.forEach((value, paramName) => {
                            this.setFilter(paramName);
                        });

                        const filterParams = Object.entries(this.filters)
                            .filter(([key, value]) => value)
                            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                            .join('&');

                        if (filterParams) {
                            opts.push(filterParams);
                        }

                        opts = opts.filter(Boolean).join('&');

                        if (pickupLocation.walk_in === 1) {
                            this.redirectWalkIn(pickupLocation);
                        } else {
                            top.location = `${path}?${opts}`;
                        }
                    }
                })
                .catch((error) => {
                    if (pickupLocation.walk_in === 1) {
                        this.redirectWalkIn(pickupLocation);
                    } else {
                        this.form.busy = false;
                        this.form.success = false;

                        this.$store.dispatch('createError', error);
                    }
                });
        },
        validateChildInputs() {
            this.clearChildValidation();
            Bus.$emit('validate');
        },
        clearChildValidation() {
            Bus.$emit('clear-validation');
        },
        formIsValid() {
            return !this.errors.any();
        },
        getCountries() {
            this.$store.dispatch('fetchCountries').catch((error) => {
                this.$store.dispatch('createFatalError');
            });
        },
        getLocation() {
            if (this.urlParams.has('puid')) {
                const pickupLocationId = this.urlParams.get('puid');

                this.setLocation(pickupLocationId, {
                    location_id: pickupLocationId,
                }).then((response) => {
                    const location = this.locations.filter((locationItem) => {
                        return locationItem.id == pickupLocationId;
                    });

                    this.countrySelected = true;
                    this.pickupLocation = location[0];

                    if (this.urlParams.has('duid') && this.urlParams.get('duid') !== pickupLocationId) {
                        const dropoffLocationId = this.urlParams.get('duid');

                        this.$store.dispatch('setDropoffDifferent', true);

                        this.setLocation(dropoffLocationId, {
                            location_id: dropoffLocationId,
                        }).then((response) => {
                            const location = this.locations.filter((locationItem) => {
                                return locationItem.id == dropoffLocationId;
                            });

                            this.countrySelected = true;
                            this.dropoffLocation = location[0];
                        });
                    } else {
                        this.dropoffLocation = location[0];
                    }
                });
            } else if (window.greenmotion.searchForm.pickupLocationId) {
                this.$store
                    .dispatch('fetchLocations', {
                        country: window.greenmotion.franchiseCountry,
                        location_id: window.greenmotion.searchForm.pickupLocationId,
                    })
                    .then((response) => {
                        const location = this.locations.filter((locationItem) => {
                            return locationItem.id == window.greenmotion.searchForm.pickupLocationId;
                        });

                        this.countrySelected = true;
                        this.pickupLocation = location[0];
                        this.dropoffLocation = location[0];
                    })
                    .catch((error) => {
                        this.$store.dispatch('createFatalError');
                    });
            }
        },
        setLocation(locationId, payload) {
            return new Promise(async (resolve, reject) => {
                let location = null;

                this.$store
                    .dispatch('fetchLocations', payload)
                    .then((response) => {
                        location = this.locations.filter((locationItem) => {
                            return locationItem.id === locationId;
                        });

                        resolve(location);
                    })
                    .catch((error) => {
                        this.$store.dispatch('createFatalError');
                    });
            });
        },
        getLocations() {
            this.locationsLoading = true;
            this.$store
                .dispatch('fetchLocations', window.greenmotion.franchiseCountry)
                .then((response) => {
                    this.locationsLoading = false;
                    const location = this.locations.filter((locationItem) => {
                        return locationItem.id == window.greenmotion.searchForm.pickupLocationId;
                    });
                    this.countrySelected = true;
                    this.pickupLocation = location[0];
                    this.dropoffLocation = location[0];
                })
                .catch((error) => {
                    this.$store.dispatch('createFatalError');
                });
        },
        redirectToMainSite() {
            const path = `/redirect/worldwide${this.promoCode ? `?promo=${this.promoCode}` : ''}`;
            if (this.isEmbedded()) {
                top.location = path;
            } else {
                this.$router.push({
                    path: path,
                });
                this.$router.go(0);
            }
        },
    },
    created() {
        this.locale = window.greenmotion.locale;
        moment.locale(Globals.convertLocaleForMoments(this.locale));
        this.getCountries();
        this.getUserLocation();

        this.getLocation();
    },
    mounted() {
        this.lockedPickupLocation = window.greenmotion.searchForm.lockedPickupLocation;
        this.promoCode = window.greenmotion.searchForm.promoCode ? window.greenmotion.searchForm.promoCode : '';
        this.driverHasStandardAge = this.driverAge == 30 ? true : false;
    },
};
</script>

<style lang="scss">
.date-picker {
    .form-control {
        border: none !important;
    }
}
.date-picker-input {
    input {
        width: 100%;
        height: 100%;
    }
}
.el-loading-mask {
    max-width: 10%;
    margin-bottom: 1.5rem;
    .el-loading-spinner {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        .circular {
            width: 100%;
            min-width: 5rem;
        }
        .el-loading-text {
            margin: 0;
        }
    }
}
</style>
<style scoped lang="scss">
@import '../../../../stylesheets/helpers/_breakpoint.scss';
/*.blocked-fields::before {*/
/*    content: '';*/
/*    position: absolute;*/
/*    width: 100%;*/
/*    height: 100%;*/
/*    opacity: 0.8;*/
/*    background-color: #fff;*/
/*    z-index: 9999;*/
/*}*/

.app-padding {
    padding-bottom: 100px !important;
}

.nav-tabs a {
    font-size: 13px;
}
.nav-tabs a:hover {
    text-decoration: none;
    color: var(--us-dark-gray);
}
.booking-form {
    background: var(--white);
    border-radius: 10px;
    padding: 20px;
}
.date-picker-inputs {
    position: relative;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    .date-fields,
    .time-fields {
        position: relative;
        left: 1rem;
        top: 0.25rem;
        max-width: 65%;
    }
    .date-icon-field,
    .time-icon-field {
        position: absolute;
        right: 0;
        top: 0.25rem;
        height: 1.8rem;
        max-width: 35%;
    }
    .date-picker,
    .date-overlay {
        position: absolute;
        width: 85%;
        height: 75%;
        top: 0.75rem;
        left: 1rem;
    }
    .date-overlay {
        z-index: 50;
        background-color: #fff;
        pointer-events: none;
    }
    .pickup-date-picker,
    .dropoff-date-picker {
        width: 100%;
    }
    .pickup-date-picker {
        margin-right: 5px;
    }
    .dropoff-date-picker {
        margin-left: 5px;
        position: relative;
        &:before {
            content: '';
            position: absolute;
            left: -20px;
            top: 50%;
            transform: translateY(-50%);
            height: 30px;
            width: 30px;
            z-index: 55;
            background: url('/images/svgs/date-arrow.svg') center center no-repeat var(--gray-100);
            border-radius: 50%;
        }
    }
    .date-picker-input {
        text-align: center;
        border: 1px solid var(--gray-200);
        border-radius: 4px 4px 0 0;
        margin: 0 auto;
        padding: 20px;
        position: relative;
        height: 100%;
        min-height: 110px;
        span {
            display: block;
        }
        & :deep() input[type='date'] {
            height: 100%;
            width: 100%;
        }
        & :deep() input[type='text'] {
            height: 100%;
            width: 100%;
        }
        &-weekday,
        &-month {
            font-size: 1.4rem;
            font-weight: 500;
            color: var(--gray-500);
        }
        &-day {
            font-weight: bold;
            font-size: 2.4rem;
            color: var(--gray-500);
        }
    }
    .date-picker-input-sm {
        border: 1px solid var(--gray-200);
        border-radius: 4px 4px 0 0;
        margin: 0 auto;
        padding: 1rem;
        position: relative;
        height: 4.5rem;
        width: 100%;
        & :deep() input[type='date'] {
            height: 100%;
            width: 100%;

            -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
            filter: alpha(opacity=0);
            -moz-opacity: 0;
            -khtml-opacity: 0;
            opacity: 0;
        }
        &-weekday,
        &-month {
            font-size: 1.6rem;
            font-weight: 500;
            color: var(--gray-400);
        }
        &-day {
            font-weight: bold;
            font-size: 1.6rem;
            color: var(--gray-400);
        }
    }
}
.time-picker-inputs {
    position: relative;
    display: flex;
    justify-content: space-between;
    .pickup-time-picker,
    .dropoff-time-picker {
        width: 100%;
    }
    .pickup-time-picker {
        margin-right: 5px;
    }
    .dropoff-time-picker {
        margin-left: 5px;
        position: relative;
    }
    .time-picker {
        width: 100%;
    }
}
.driver-age-inputs {
    .driver-age-input {
        clear: both;
    }
}
.submit-button {
    @include breakpoint(sm) {
        margin: 0;
    }
    :deep() .gm-button {
        box-shadow: 2px 2px #dfe0e1;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        button.btn {
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
        @include breakpoint(sm) {
            box-shadow: none;
            border-radius: 0;
            button.btn {
                border-radius: 5px;
            }
        }
    }
}
.floating-label {
    margin-top: -2rem;
    clear: both;
    label {
        line-height: 2.3;
        margin-left: 30px;
        &.not-empty,
        &.focus {
            margin-left: 0px;
        }
    }
}
.floating-label input:not(:placeholder-shown) + label,
.floating-label input:focus + label,
.floating-label input + label.focus {
    margin-left: 0;
}
input.genuine-input::-webkit-input-placeholder {
    opacity: 0 !important;
    transition: inherit;
}
input.genuine-input:focus::-webkit-input-placeholder {
    opacity: 1;
}
</style>
